module.exports = ".heart {\n  width: 1rem; }\n"